import { useMemo } from 'react';
import { Divider, Paper, Box, Card, CardContent, CardMedia, Typography } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';

// common
import TopicMark from "@imgs/icon-camp-etc.png";
import info from "@data/company-info";


const kClr_m1 = "#FA9A29";
const kClr_m3 = "#FFF3E6";

export default function InfoCard() {
  const aryInfo: { title: string, value: string }[] = useMemo(() => {
    return [
      {
        title: "社　名",
        value: info.name,
      },
      {
        title: "代表者",
        value: info.owner,
      },
      {
        title: "設　立",
        value: info.create,
      },
      {
        title: "資本金",
        value: info.capital,
      },
    ]
  }, [])
  return (
    <Box component="section" id="point" sx={{ mt: 2, pb: 0 }}>
      <Box component="div" className="container">
        <Paper sx={{
          px: { xs: 1, sm: 3 }, py: { xs: 1, sm: 3 },
          bgcolor: kClr_m3,
          border: 3, borderColor: kClr_m1, borderRadius: 4
        }}
        >
          <Card >
            <CardMedia
              sx={{ height: 20 }}
              title="green iguana"
            />
            <CardContent>
              <Grid xs={12} sm={12} sx={{ mt: 1, ml: { xs: 1, sm: 2 }, fontSize: '18px', fontWeight: 600 }}>
                <Box component="img" src={TopicMark}
                  sx={{ width: '40px', height: '40px', mb: '-10px', mr: '5px', border: 0, borderRadius: '2px' }}
                />
                会社情報
              </Grid>
              <Divider sx={{ mb: 3 }} />
              <Grid container spacing={2} sx={{ m: 2 }}>
                {
                  aryInfo.map((pair: { title: string, value: string }) => (
                    <>
                      <Grid xs={12} sm={4}>
                        <Typography variant="subtitle1" component="div" sx={{ fontWeight: 700 }}>
                          {pair.title}
                        </Typography>
                      </Grid>
                      <Grid xs={12} sm={8}>
                        <Typography variant="subtitle1">
                          {pair.value}
                        </Typography>
                      </Grid>
                    </>
                  )
                  )
                }
                <>
                  <Grid xs={12} sm={4}>
                    <Typography variant="subtitle1" component="div" sx={{ fontWeight: 700 }}>
                      本部所在地
                    </Typography>
                  </Grid>
                  <Grid xs={12} sm={8}>
                    <Typography variant="subtitle1">
                      {info.address}<br />
                      {info.addr2}
                    </Typography>
                  </Grid>
                </>
              </Grid>
            </CardContent>
          </Card>
        </Paper>
      </Box>
    </Box>
  );
}
